import React, {useContext, useEffect, useState} from "react";
import styled from "styled-components";
import { Modal } from "@redq/reuse-modal";
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { connect, useSelector } from "react-redux";
import { doSupplierLogin, verifyMerchantOTP, doSupplierLoginWithOtp } from "../../store/actions/authAction";
import { AuthContext } from "../../contexts/auth/auth.context";
import * as Constants from "../../constants/Constant";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { Modal as OTPModal } from "react-bootstrap";
import OtpField from 'react-otp-field';
import './supplier.css';
import { ShowPassword } from "../../containers/SignInOutForm/SignInOutForm.style";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import CloudflareTurnstile from "../../components/CloudflareTurnstile";

const Heading = styled.h3`
  font-size: 25px;
  font-weight: 700;
  color: #9cc54b;;
  line-height: 1.2;
  margin-bottom: 25px;
  width: 100%;
  text-align: center;
`;

const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 130px 0 60px 0;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .submit_btn {
    background-color : #9cc54b;
    outline: none;
    border:none;
    /* min-width: 250px; */
  }

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

export const HelpPageContainer = styled.div`
  background-color: transparent;
  padding: 0;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  @media (min-width: 990px) {
    width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 989px) {
    padding: 60px;
  }
`;

export const ErrorContainer = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`;

const OTPContainer = styled.div`
.otp-field {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75em;
  margin-bottom: 0.25em;
}

.otp-field input {
  display: inline-block;
  width: 2.25rem;
  height: 3.25rem;
  font-size: 1.75em;
  text-align: center;
  border-radius: 0.175em;
  box-shadow: 0 0 0 1px #1e272e;
  outline: none;
  border: none;
  transition: all 0.2s ease;
}

.otp-field input:focus {
  box-shadow: 0 0 0 2px #9cc54b;
  scale: 1.125;
}
`;

const SupplierLoginScreen = (props) => {

  const { authDispatch } = useContext(AuthContext);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [errormsg, setErrorMsg] = React.useState("");
  const [cerror, setCError] = React.useState("");
  const captcha = React.useRef(null);
  const [token, setToken] = useState(null);

  const [showPassword, setShowPassword] = React.useState(false);
  const cartType = useSelector(state => state.cartReducer.cartType);

  const [showOTPModal, setShowOTPModal] = React.useState(false);
  const [otp, setOtp] = React.useState("");
  const [clock, setClock] = React.useState(60);

  let minutes = Math.floor(clock / 60);
  let seconds = clock - (Math.floor(clock / 60) * 60);

  let supplier = localStorage.getItem("supplier");
  let admin = localStorage.getItem("admin");
  let key = localStorage.getItem("key");
  
  if(supplier != null) {
    window.location.href = "/supplier/orders";
  }
  if(admin != null) {
    window.location.href = "/admin/orders";
  }

  useEffect(() => {
    localStorage.removeItem("key");
  }, []);

  const didLoginFail = () => {
    if(!props.success){
      setCError(true);
    }
    setLoading(false);
  };

  const loginCallback = (e) => {
    e.preventDefault();
    if (!validateEmail(email)) return;

    setLoading(true);
    if (token) {
      if (Constants.envMode === "Production") {
        props.doSupplierLoginWithOtp({ email: email, password: password }, setShowOTPModal);
      } else {
        props.doSupplierLogin({ email: email, password: password });
      }
    } else {
      alert('Cannot Login, yet!')
    }
    setTimeout(() => {
      didLoginFail();
    }, 1000);
  };

  useEffect(() => {
    if (otp.length < 6) return;
    const body = { otp, email, password };
    props.verifyMerchantOTP(body);
  }, [otp]);

  const handleResendOTP = () => {
    setClock(60);
    setOtp("");
    props.doSupplierLoginWithOtp({ email: email, password: password }, setShowOTPModal);
  }

  React.useMemo(() => {
    if (!key) return;

    let countdown = setTimeout(() => {
      if (clock === 0) return;
      setClock(clock - 1);
    }, 1000);

    return () => clearTimeout(countdown);

  }, [clock, key]);

  useEffect(() => {
    return ()=>{
      setLoading(false);
      setError(false);
      setErrorMsg("");
      setEmail("");
      setPassword("");
      setCError("");
    }
  },[]);

  useEffect(() => {
    if (props.success) {
      authDispatch({ type: "SIGNIN_SUCCESS" });
    }
  }, [props.success]);
  const validateEmail = (value) => {
    const trimmedEmail = value.trim();

    if (!trimmedEmail) {
      setErrorMsg("Enter an email");
      setError(true);
      return false;
    }
    else if ((Constants.email_reg.test(trimmedEmail)) === false) {
      setErrorMsg("Enter a valid email");
      setError(true);
      return false;
    }

    setErrorMsg("");
    setError(false);
    return true;
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);

    if (error) {
      setErrorMsg("");
      setError(false);
    }
  };

  const handleEmailBlur = (e) => {
    const value = e.target.value;

    // Password managers can briefly blur the empty field while opening their
    // account picker. Empty values are still validated when the form submits.
    if (!value.trim()) return;
    validateEmail(value);
  };

  const handleVerify = (token) => {
    setToken(token);
  }

  return (
    <Modal>
      <HelpPageWrapper>
        <HelpPageContainer>
        <Card >
          <Card.Body>
          <Heading>Login</Heading>

          <Form onSubmit={loginCallback}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control 
                type="email" 
                name="email"
                autoComplete="username"
                placeholder="Enter email" 
                value={email} 
                onChange={handleEmailChange}
                onBlur={handleEmailBlur}
                required />
              <Form.Text className="text-muted">
                Your email which is listed in our system.
              </Form.Text>
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <div className="position-relative">
                <Form.Control 
                  type={ showPassword ? `text` : `password`}
                  name="password"
                  autoComplete="current-password"
                  placeholder="Password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                />
                <ShowPassword className={cartType} style={{right: '2%'}} variant="outline-secondary" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </ShowPassword>
              </div>
            </Form.Group>

            <Form.Group controlId="formBasicCheckbox">
              <Form.Check type="checkbox" label="Remember me" />
            </Form.Group>
            
            <Form.Group>
              {/*<ReCAPTCHA*/}
              {/*  sitekey={Constants.captchaKey}*/}
              {/*  ref={captcha}*/}
              {/*  onChange={() => captcha.current.getValue()}*/}
              {/*/>*/}
              <div className={"d-flex"} style={{backgroundColor:"#ffffff"}}>
                <CloudflareTurnstile
                    sitekey={Constants.sitekey}
                    onVerify={(token) => handleVerify(token)}
                    onError={(error) => console.log(error)}
                    className="turnstile-widget"
                    style={{ backdropColor:"#ffffff" }}
                />
              </div>
            </Form.Group>
                
            {
              !key ? 
                <Button  type="submit" className="submit_btn" disabled={loading}>Submit</Button> 
                : <Button variant="success" disabled={loading} onClick={() => setShowOTPModal(true)}>Verify</Button>
            }
            
            <br/>
            {error === true ? (
            <ErrorContainer>
              <span className="text-danger">{errormsg}</span>
            </ErrorContainer>
            ) : null}
            {cerror && props.loginresponsemsg === "invalid password" && error !== true ? <ErrorContainer><span className="text-danger">{props.loginresponsemsg}</span></ErrorContainer> : null
            }
            {cerror && props.loginresponsemsg === "Disabled user" && error !== true ? <ErrorContainer><span className="text-danger">{props.loginresponsemsg}</span></ErrorContainer> : null
            }
            {/* {cerror ? <span className="text-danger">Wrong password. Please try again or <span onClick={(e) => {
              e.preventDefault();
              authDispatch({
                type: "FORGOTPASS",
              });
              }} 
              style={{color: "green", textDecoration: "underline", fontWeight: "700", cursor: "pointer"}}>RESET</span> &nbsp;it</span> : null} */}

          </Form>
          </Card.Body>
          </Card>
          <OTPModal
            centered
            scrollable
            backdrop="static"
            show={showOTPModal}
            onHide={() => setShowOTPModal(false)}
          >
            <OTPModal.Header closeButton>
              <div className="w-100 d-flex flex-column justify-content-between align-items-center">
                <img src={require(`../../../src/assets/icons/delishop_logo2.svg`)} alt="Delishop" width="120px"/>
                <p className="h4 mt-2">Enter your code</p>
              </div>
            </OTPModal.Header>
            <OTPModal.Body>
              <div className="d-flex flex-column p-1">
                <p className="d-block text-center text-muted mb-4">We send a security code to <span className="text-success">{email}</span></p>
                <OTPContainer>
                  <OtpField
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    onChangeRegex={/^([0-9]{0,})$/}
                    autoFocus
                    inputProps={{ className: 'otp-field' }}
                  />
                </OTPContainer>
              </div>
            </OTPModal.Body>
            <OTPModal.Footer>
              <div className="w-100 d-flex align-items-center justify-content-end">
                {clock > 0 &&  <p className="text-muted mr-2">Resend code in</p>}
                {
                  clock === 0 ?
                    <Button variant="success" onClick={handleResendOTP}>Resend Code</Button>
                    : <span className="text-primary">0{minutes} : {seconds < 10 && "0"}{seconds} s</span>
                }

              </div>
            </OTPModal.Footer>
          </OTPModal>
        </HelpPageContainer>
      </HelpPageWrapper>
    </Modal>
  );
}
const mapStateToProps = (state) => {
  return {
    success: state.authReducer.success,
    loginresponsemsg: state.authReducer.loginresponsemsg
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doSupplierLogin: (body) => doSupplierLogin(body, dispatch),
    doSupplierLoginWithOtp: (body, setShowOTPModal) => doSupplierLoginWithOtp(body, setShowOTPModal, dispatch),
    verifyMerchantOTP: (body) => verifyMerchantOTP(body, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SupplierLoginScreen);
